import React from "react";
import { FaBullseye, FaEye } from "react-icons/fa6";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

// Office photo ("Great Ideas Build Great Businesses"). File: public/img/about-story.jpg (cropped from the design
// mockup; swap in a high-res export when available).
const storyImg = "/img/about-story.jpg";

const Pill = ({ children }) => (
  <span className="inline-block rounded-full bg-[#E3EDFF] px-[14px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
    {children}
  </span>
);

const cards = [
  {
    icon: FaBullseye,
    title: "Our Mission",
    text: "To empower businesses with innovative and reliable digital solutions that solve real-world problems and create long-term value.",
    tone: "bg-[#FFE4E6] text-[#EF4444]",
  },
  {
    icon: FaEye,
    title: "Our Vision",
    text: "To be a global technology partner, recognized for our quality, creativity and customer-centric approach in building a smarter digital future.",
    tone: "bg-[#E3EDFF] text-[#2563EB]",
  },
];

const AboutStory = () => (
  <section className="bg-white py-[48px] lg:py-[72px]">
    <Container className="max-w-[1200px]">
      <div className="grid items-center gap-[32px] lg:grid-cols-2 lg:gap-[48px]">
        <img
          src={storyImg}
          alt="DataMetricks office with the words Great Ideas Build Great Businesses on the wall"
          className="aspect-[4/3] h-auto w-full select-none rounded-[20px] object-cover shadow-[0_18px_50px_-24px_rgba(40,60,140,0.35)]"
        />

        <div>
          <Pill>Our Story</Pill>
          <h2 className={`mt-[14px] font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
            Turning Ideas Into
            {" "}<br />
            Impactful <span className="text-[#1E6BFF]">Digital Products</span>
          </h2>
          <p className="mt-[16px] text-[15px] leading-[1.7] text-slate-600 sm:text-[16px]">
            Founded with a simple idea &ndash; to help businesses leverage technology for real growth. Over the years, we have
            worked with startups, SMEs and enterprises across the globe, delivering high-quality digital solutions that create
            value.
          </p>
          <p className="mt-[14px] text-[15px] leading-[1.7] text-slate-600 sm:text-[16px]">
            Our journey is driven by innovation, collaboration and a commitment to client success.
          </p>
        </div>
      </div>

      <div className="mt-[56px] text-center lg:mt-[72px]">
        <Pill>Our Mission &amp; Vision</Pill>
      </div>
      <div className="m-swipe mx-auto mt-[24px] grid max-w-[1000px] gap-[20px] md:grid-cols-2">
        {cards.map((c) => (
          <div
            key={c.title}
            className="flex items-start gap-[20px] rounded-[18px] bg-white p-[24px] shadow-[0_14px_36px_-24px_rgba(40,60,140,0.35)] sm:p-[28px]"
          >
            <span className={`inline-flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-full text-[30px] ${c.tone}`}>
              <c.icon />
            </span>
            <div>
              <h3 className={`font-bold text-[#0B1A4A] ${H3_SIZE}`}>{c.title}</h3>
              <p className="mt-[8px] text-[14px] leading-[1.6] text-slate-600">{c.text}</p>
            </div>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default AboutStory;
